import { FC } from 'react';
import Arrow from '/public/icons/chevron right.svg?react';
import {
  cvaProfileItemCounter,
  cvaProfileItemInner,
  cvaProfileItemProfit,
  cvaProfileItemText,
} from '~/entities/ProfileItem/ProfileItemStyles';
import { Link } from '@remix-run/react';
import { OwnBlock } from '~/shared/ui/OwnBlock/OwnBlock';
import { priceFormatter } from '~/shared/utils/priceFormatter';

interface Props {
  title: string;
  alternative?: boolean; // для альтернативного отображения вместо иконки
  profit?: number;
  to: string;
  counter?: number;
  target?: '_blank';
}

export const ProfileItem: FC<Props> = ({
  title,
  alternative,
  to,
  profit,
  counter,
  target,
}) => {
  return (
    <OwnBlock className="!p-0">
      <Link to={to} target={target} className={cvaProfileItemInner()}>
        <h3 className={cvaProfileItemText()}>{title}</h3>
        {alternative ? (
          <span className={cvaProfileItemProfit()}>
            {priceFormatter(profit ?? 0)}
          </span>
        ) : (
          <Arrow height={'2.4rem'} width={'2.4rem'} />
        )}
        {counter ? (
          <div className={cvaProfileItemCounter()}>{counter}</div>
        ) : null}
      </Link>
    </OwnBlock>
  );
};
